import { Anchor, Badge, Code, Flex, Grid, Table, Text } from "@mantine/core";
import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mantine";
import {
  DetailsCard,
  DetailsUserCard,
} from "components/common/show/DetailsPair";
import { History } from "components/common/show/History";
import { colorsByKind } from "entities/plan/kind";
import { Subscription } from "entities/subscription";
import { colorsByStatus } from "entities/subscription/status";
import { colorsByStatus as invoiceColorsByStatus } from "entities/invoice/status";
import { Link } from "react-router-dom";
import {
  formatChargebeeAmount,
  getInvoiceUrl,
  getSubscriptionUrl,
} from "utils/chargebee";

export const SubscriptionShow = () => {
  const { queryResult } = useShow<Subscription>();
  const { data, isLoading } = queryResult;
  const subscription = data?.data;

  if (!subscription) return <div />;

  return (
    <Show isLoading={isLoading}>
      <Grid>
        <Grid.Col span={8}>
          <Flex gap="sm" direction="column">
            <DetailsCard title="Invoices">
              <Table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Remote ID</th>
                    <th>Status</th>
                    <th>Total</th>
                    <th>Amount Paid</th>
                    <th>Paid At</th>
                  </tr>
                </thead>
                <tbody>
                  {subscription.invoices.map((invoice) => (
                    <tr>
                      <td>
                        <Anchor
                          component={Link}
                          to={`/invoices/show/${invoice.id}`}
                        >
                          {invoice.id}
                        </Anchor>
                      </td>
                      <td>
                        <Anchor href={getInvoiceUrl(invoice.remote_id)}>
                          {invoice.remote_id}
                        </Anchor>
                      </td>
                      <td>
                        <Badge color={invoiceColorsByStatus[invoice.status]}>
                          {invoice.status}
                        </Badge>
                      </td>
                      <td>{formatChargebeeAmount(invoice.total)}</td>
                      <td>{formatChargebeeAmount(invoice.amount_paid)}</td>
                      <td>{invoice.paid_at?.toString()}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </DetailsCard>
            <History<Subscription>
              resources={"subscriptions"}
              entityId={subscription.id}
            />
          </Flex>
        </Grid.Col>
        <Grid.Col span={4}>
          <Flex direction="column" gap="sm">
            <DetailsUserCard user={subscription.user} />
            <DetailsCard title="ID">
              <Text>{subscription.id}</Text>
            </DetailsCard>
            <DetailsCard title="Remote ID">
              <Anchor
                component={Link}
                to={getSubscriptionUrl(subscription.remote_id)}
              >
                {subscription.remote_id}
              </Anchor>
            </DetailsCard>
            {subscription.tea_addon_subscription_id && (
              <DetailsCard title="Tea Addon Subscription">
                <Anchor
                  component={Link}
                  to={`/tea_addon_subscriptions/show/${subscription.tea_addon_subscription_id}`}
                >
                  <Badge color="blue">
                    #{subscription.tea_addon_subscription_id}
                  </Badge>
                </Anchor>
              </DetailsCard>
            )}
            <DetailsCard title="Plan">
              <Anchor
                component={Link}
                to={`/plans/show/${subscription.plan.id}`}
              >
                <Badge color={colorsByKind[subscription.plan.kind]}>
                  {subscription.plan.name}
                </Badge>
              </Anchor>
            </DetailsCard>
            <DetailsCard title="Status">
              <Badge color={colorsByStatus[subscription.status]}>
                {subscription.status}
              </Badge>
            </DetailsCard>
            <DetailsCard title="Next Billing At">
              <Code>{subscription.next_billing_at}</Code>
            </DetailsCard>
            <DetailsCard title="Last Synced At">
              <Code>{subscription.last_synced_at}</Code>
            </DetailsCard>
          </Flex>
        </Grid.Col>
      </Grid>
    </Show>
  );
};
